import React, {useCallback, useContext, useEffect, useState} from 'react';
import {
	Button, Menu,
	MenuItem,
	Paper, Table, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip,
	Typography
} from "@mui/material";
import {useHistory} from "react-router-dom";
import clsx from 'clsx';
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import IconButton from "@mui/material/IconButton";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {AppContext} from "../../../App";
import {setCloseSnackbar, setLang, setThemeType} from "../../../services/AppServices";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import {langDict, languages} from "../../../strings/LanguageDictionary";
import Copyright from "../../auth/utils/Copyright";
import Background from "../../../assets/Ocean-bg.jpg";
import TableBody from "@mui/material/TableBody";
import {farmacie} from "../../../utils/arrays/FarmacieConvenzionate";
import {capitalizeWords} from "../../../utils/GenericUtils";

const FarmacieConvenzionateAsl = () => {
	let history = useHistory();
	const contattaciClasses = ContattaciStyle();
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const [anchorEl, setAnchorEl] = useState(null);
	const [value, setValue] = useState("");
	
	const handleClose = (key) => {
		if (key) {
			setLang(key, appContext.dispatch)
		}
		setAnchorEl(null);
	};
	
	const goToHome = useCallback(() => {
		history.push("/contattaci");
	}, [history])
	
	useEffect(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch])
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.mainNoBgCol}>
				<header className={contattaciClasses.header}>
					<Tooltip
						title={appContext.state.theme.palette.mode === "light" ? languages[appContext.state.lang].OCEAN__MAIN_GLOBAL_THEMA_TEXT : languages[appContext.state.lang].OCEAN__GLOBAL_THEMA_TEXT_DARK}>
						<IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            style={{color: appContext.state.theme.palette.mode === "light" ? "#FFF" : "#000"}}
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
								appContext.state.theme, appContext.dispatch)}
                            size="large">
							{
								appContext.state.theme.palette.mode === "light" ?
									<Brightness4TwoToneIcon/> :
									<Brightness5TwoToneIcon/>
							}
						</IconButton>
					</Tooltip>
					<Menu
						PaperProps={{
							className: clsx(classes.roundBorder, classes.transparent, classes.blurred20, classes.shadow24)
						}}
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={() => handleClose()}
					>
						{
							Object.entries(langDict).map(([key, val]) => {
								return (
									<MenuItem style={{width: 300}} key={key} onClick={() => handleClose(key)}>{val.flag}<span
										style={{paddingLeft: 8}}>{val.label}</span></MenuItem>
								)
							})
						}
					</Menu>
					<Typography variant={"h2"} component={"h1"} className={contattaciClasses.title}>
						<b>{languages[appContext.state.lang].CONTATTACI_FARM_TICKET_TITLE_}</b>
					</Typography>
				</header>
				<article className={contattaciClasses.article}>
					<Paper
						className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>
						
						<Typography variant={"subtitle1"} color={"textSecondary"}>
							Qui sotto trovi tutte le farmacie convenzionate con l'Asl città di Torino e ti sarà possibile filtrarle
							per nome, indirizzo o CAP.
						</Typography>
						
						<TextField value={value}
						           onChange={(e) => setValue(e.target.value)}
						           style={{margin: 10, paddingBottom: 10}}
						           label={"Cerca per nome, indirizzo o CAP"}
						           fullWidth/>
						
						<TableContainer>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell><b>Nome farmacia</b></TableCell>
										<TableCell><b>Indirizzo</b></TableCell>
										<TableCell><b>CAP</b></TableCell>
										<TableCell><b>Email</b></TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{
										farmacie
											.sort((a, b) => {
												if (a.nome < b.nome) {
													return -1;
												}
												if (a.nome > b.nome) {
													return 1;
												}
												return 0;
											})
											?.filter(item => item.nome.toUpperCase().includes(value.toUpperCase()) || item.indirizzo.toUpperCase().includes(value.toUpperCase()) || item.cap === value)
											?.map(farmacia => {
												return (
													<TableRow hover key={farmacia.nome}>
														<TableCell scope={"row"}>{capitalizeWords(farmacia.nome)}</TableCell>
														<TableCell>{capitalizeWords(farmacia.indirizzo)}</TableCell>
														<TableCell>{farmacia.cap}</TableCell>
														<TableCell>{farmacia.email}</TableCell>
													</TableRow>
												)
											})
									}
								</TableBody>
							</Table>
						</TableContainer>
					</Paper>
					<Button className={clsx(classes.roundBorder, classes.margin2, classes.blurred20)}
					        style={{borderRadius: 24}}
					        size={"small"} variant={"contained"} color={"primary"}
					        startIcon={<ArrowBackTwoToneIcon/>} onClick={goToHome}>
						{languages[appContext.state.lang].CONTATTACI_RETURN_HOME_BUTTON}
					</Button>
				</article>
				<footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}>
					<Copyright/>
				</footer>
			</main>
        </React.Fragment>
    );
};

export default React.memo(FarmacieConvenzionateAsl);
